var _defs, _path, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconFinal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "normal",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    className: "wasm-icon-linear-gradient",
    id: "wasm-final-icon-linear-gradient",
    x1: 44.31,
    y1: 32,
    x2: 30.55,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m48.02,16.6c3.3,0,5.99,2.69,5.99,5.99,0,2.46-2.4,11.63-3.98,17.7-.65,2.49-1.21,4.64-1.6,6.27-.12.5-.53.86-.98.86-.06,0-.13,0-.19-.02-.44-.08-.78-.56-.78-1.09v-4.67c0-2.62-2.13-4.75-4.75-4.75-2.36,0-4.75,1.8-4.75,5.25v4.17c0,.53-.34,1.01-.78,1.09-.07.01-.13.02-.2.02-.46,0-.86-.35-.98-.85-.39-1.63-.94-3.82-1.58-6.35-1.47-5.8-3.93-15.52-3.93-17.63,0-3.3,2.69-5.99,5.99-5.99.82,0,1.61.16,2.36.48,1.24.53,2.55.8,3.91.8s2.67-.27,3.91-.8c.74-.32,1.54-.48,2.36-.48m0-2.78c-1.23,0-2.4.25-3.46.71-.89.38-1.85.58-2.81.58s-1.92-.19-2.81-.58c-1.06-.46-2.23-.71-3.46-.71-4.84,0-8.77,3.93-8.77,8.77,0,3.33,4.14,18.48,5.59,24.62.41,1.73,1.91,2.99,3.69,2.99.23,0,.47-.02.71-.07,1.8-.33,3.05-1.99,3.05-3.82v-4.17c0-1.59.88-2.47,1.97-2.47s1.97.88,1.97,1.97v4.67c0,1.83,1.25,3.49,3.06,3.83.24.04.47.06.7.06,1.77,0,3.27-1.26,3.69-2.99,1.48-6.14,5.66-20.82,5.66-24.62,0-4.84-3.93-8.77-8.77-8.77h0Z",
    fill: "url(#wasm-final-icon-linear-gradient)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "wasm-icon-fill",
    transform: "translate(4.75 49.92)",
    fontFamily: "SofiaPro-Black, Sofia Pro",
    fontSize: "52.48px",
    fontWeight: 800,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconFinal);
export default __webpack_public_path__ + "static/media/SDS_icon_Final.361a4ee476182f9017e385afcac879e7.svg";
export { ForwardRef as ReactComponent };